import firebaseSrv from '@/services/firebaseSrv.js'
import router from '@/router.js'

export const namespaced = true

// console.log('In auth vuex store')
/*
export const state = {
  auth: {
    currentUser: null,
    displayName: null,
    roles: []
  }
}
export const mutations = {
  UPDATE_AUTH(state, auth) {
    state.auth.currentUser = auth.uid
    if (auth.displayName) {
      state.auth.displayName = auth.displayName
      state.auth.roles = auth.roles
    }
  }
}
*/
export const getters = {}
export const actions = {
  // SIGN OUT
  signOut() {
    firebaseSrv.auth.signOut().catch(error => error)
  },
  // PASSWORD
  passwordResetRequest({ dispatch }, form) {
    firebaseSrv.auth
      .sendPasswordResetEmail(form.email)
      .then(function() {
        const notification = {
          title: 'Successful password reset request ',
          type: 'success',
          message:
            'Your password reset request was successful. Please check your email account for a mail from contemporaryafricanphotography@gmail.com. The email will contain a link. Please follow the link to reset your password.'
        }
        dispatch('notification/add', notification, { root: true })
        return
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem resetting your password',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  passwordReset({ dispatch }, payload) {
    let code = payload.code
    let newPassword = payload.form.password
    firebaseSrv.auth
      .confirmPasswordReset(code, newPassword)
      .then(() => router.push({ name: 'list-entries' }))
      .catch(error => {
        const notification = {
          title: 'There is a problem resetting your password',
          type: 'error',
          code: error.code,
          message: 'New Password Problem' + error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // SIGN IN
  signIn({ dispatch }, form) {
    firebaseSrv.auth
      .signInWithEmailAndPassword(form.email, form.password)
      .then(() => {
        firebaseSrv.auth.currentUser.getIdTokenResult().then(token => {
          if (token.claims.judge) {
            return router.push({ name: 'judging-entries' })
          }

          if (token.claims.admin) {
            return router.push({ name: 'dashboard' })
          }
          return router.push({ name: 'list-entries' })
        })
      })
      .catch(error => {
        const notification = {
          title: 'There is a problem signing in',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  // REGISTER
  register({ dispatch }, form) {
    firebaseSrv.auth
      .createUserWithEmailAndPassword(form.email, form.password)
      .then(() => {
        firebaseSrv.auth.currentUser.updateProfile({
          displayName: form.name
        })
      })
      .then(() => router.push({ name: 'list-entries' }))
      /*
      .then(() => {
        commit('UPDATE_AUTH', {
          uid: firebaseSrv.auth.currentUser.uid,
          displayName: form.name
        })
      })
      */
      .catch(error => {
        const notification = {
          title: 'There is a problem creating your account',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  setRole() {
    var auth = {
      uid: firebaseSrv.auth.currentUser.uid,
      displayName: firebaseSrv.auth.currentUser.displayName,
      roles: []
    }
    firebaseSrv.auth.currentUser
      .getIdTokenResult()
      .then(token => {
        // Confirm the user is an Admin.
        if (token.claims.admin) {
          auth.roles.push('admin')
        }
        if (token.claims.judge) {
          auth.roles.push('judge')
        }
      })
      .catch(error => {
        console.log(error)
      })
    return auth
  },
  authStore({ commit }) {
    var authorised = null
    if (firebaseSrv.auth.currentUser.uid) {
      authorised = {
        uid: firebaseSrv.auth.currentUser.uid,
        displayName: firebaseSrv.auth.currentUser.displayName,
        roles: []
      }
    }
    firebaseSrv.auth.currentUser
      .getIdTokenResult()
      .then(token => {
        if (token.claims.admin) {
          authorised.roles.push('admin')
        }
        if (token.claims.judge) {
          authorised.roles.push('judge')
        }
        return authorised
      })
      .then(authorised => commit('UPDATE_AUTH', authorised))
  }
}
